













exports.default =
  data: ->
    current_user: Session.current_user
  components:
    list: require('./list')




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/templates/index.vue